<ng-container *transloco="let t">
  <pxw-modal-dialog
    #validationCouponPaymentMethodDialog
    [title]="t('endOrder.couponCodeConfirmChangePaymentTitle')"
    type="confirm"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>
        {{
          t('endOrder.couponCodeConfirmChangePaymentDescription1', {
            paymentMethods: paymentMethodsForCouponList
          })
        }}
      </p>
      <p>{{ t('endOrder.couponCodeConfirmChangePaymentDescription2') }}</p>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
